import { TranslationMap } from '@trimble-gcs/i18n-types';

export function clarityFileBrowserTranslations() {
  return {
    breadcrumbRoot: {
      text: $localize`:@@import.dialog.picker.clarity.breadcrumbRoot:Home`,
      desc: 'Anchor text to open the root folder of the file explorer.',
    },
  } satisfies TranslationMap;
}
